import BaseRateMultiplierForm from './BaseRateMultiplierForm';
import BaseRateMultiplierList from './BaseRateMultiplierList';

export default { BaseRateMultiplierList, BaseRateMultiplierForm };
